<!-- 
Bulk Upload 
-->

<app-admin-header
  [header]="header"
  [links]="links"
  [breadcrumbs]="breadcrumbs"
  [stats]="stats"
></app-admin-header>
<div class="container-fluid bulk-page-container">
  <div class="container py-4 min-vh-100">
    
    <!-- Top Messages -->
    <div class="mb-3" *ngIf="messages && messages.length > 0">
      <p-messages [(value)]="messages" [enableService]="false"></p-messages>
    </div>

    <!-- Active File / Working Data Banner (when data is loaded) -->
    <div *ngIf="data && data.length > 0" class="bulk-active-banner mb-4">
      <div class="d-flex justify-content-between align-items-center flex-wrap gap-3">
        <div class="d-flex align-items-center gap-3">
          <div class="file-badge-icon">
            <i class="pi pi-file-excel"></i>
          </div>
          <div>
            <h5 class="mb-1 text-white font-weight-bold">
              {{ selectedFileName || ('Load data file' | translator) }}
            </h5>
            <span class="badge-pill-records">
              <i class="pi pi-database mx-1"></i>
              {{ data.length }} {{ 'records' | translator }}
            </span>
          </div>
        </div>
        <div class="d-flex align-items-center gap-2">
          <button
            type="button"
            class="btn-reset-upload"
            (click)="resetCurrentData()"
            pTooltip="{{ 'Choose a file' | translator }}"
            tooltipPosition="bottom"
          >
            <i class="pi pi-refresh mx-1"></i>
            {{ 'Choose a file' | translator }}
          </button>
        </div>
      </div>
    </div>

    <!-- MAIN UPLOAD & TEMPLATE HERO SECTION (Shown when no data is loaded yet) -->
    <div *ngIf="data.length === 0 && missing_entities.length === 0" class="row g-4 mb-5">
      <!-- Upload Card / Dropzone -->
      <div class="col-lg-7 col-md-12">
        <div class="bulk-upload-card h-100">
          <div class="card-header-custom mb-3">
            <div class="header-icon-wrapper">
              <i class="pi pi-cloud-upload"></i>
            </div>
            <div>
              <h3 class="card-title-text">{{ 'Choose a file' | translator }}</h3>
              <p class="card-subtitle-text mb-0">
                {{ 'Choose the Excel file you want to download' | translator }}
              </p>
            </div>
          </div>

          <!-- Dropzone area -->
          <div
            class="dropzone-area"
            [class.dragging]="isDragging"
            (dragover)="onDragOver($event)"
            (dragleave)="onDragLeave($event)"
            (drop)="onFileDrop($event)"
          >
            <input
              type="file"
              id="bulkFileInput"
              class="hidden-file-input"
              (change)="changeListener($event)"
              accept=".csv, .xlsx, .xls"
            />
            
            <div class="dropzone-content text-center">
              <div class="dropzone-icon-circle">
                <i class="pi pi-file-excel"></i>
              </div>
              <h4 class="dropzone-title">
                {{ 'Choose a file' | translator }}
              </h4>
              <p class="dropzone-sub">
                {{ 'Choose the Excel file you want to download' | translator }} (.xlsx, .csv)
              </p>
              
              <label for="bulkFileInput" class="btn-browse-file">
                <i class="pi pi-folder-open mx-2"></i>
                {{ 'Choose a file' | translator }}
              </label>
            </div>
          </div>

          <!-- Helper badges -->
          <div class="d-flex justify-content-center align-items-center gap-3 mt-3 format-badges flex-wrap">
            <span class="format-badge"><i class="pi pi-check-circle mx-1"></i> .XLSX</span>
            <span class="format-badge"><i class="pi pi-check-circle mx-1"></i> .CSV</span>
            <span class="format-badge"><i class="pi pi-shield mx-1"></i> {{ 'Excel' | translator }}</span>
          </div>
        </div>
      </div>

      <!-- Quick Template Download & Info Card -->
      <div class="col-lg-5 col-md-12">
        <div class="bulk-template-card h-100 d-flex flex-column justify-content-between">
          <div>
            <div class="card-header-custom mb-3">
              <div class="header-icon-wrapper template-icon-bg">
                <i class="pi pi-download"></i>
              </div>
              <div>
                <h3 class="card-title-text">{{ 'Download template' | translator }}</h3>
                <p class="card-subtitle-text mb-0">
                  {{ 'Add the Excel file to download the data' | translator }}
                </p>
              </div>
            </div>

            <p class="template-info-p">
              {{ 'You can use Scratch to upload data' | translator }}
            </p>

            <div class="template-steps">
              <div class="step-item">
                <span class="step-number">1</span>
                <span>{{ 'Download template' | translator }}</span>
              </div>
              <div class="step-item">
                <span class="step-number">2</span>
                <span>{{ 'Load data file' | translator }}</span>
              </div>
              <div class="step-item">
                <span class="step-number">3</span>
                <span>{{ 'Entities' | translator }} & {{ 'Data generation' | translator }}</span>
              </div>
            </div>
          </div>

          <div class="mt-4 text-center">
            <button
              type="button"
              class="btn-open-template-dialog w-100"
              (click)="tempdialog = true"
            >
              <i class="pi pi-download mx-2"></i>
              {{ 'Download template' | translator }}
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- SAVED DRAFTS SECTION (Shown when no data is loaded yet) -->
    <div *ngIf="data.length === 0 && missing_entities.length === 0" class="bulk-drafts-card mb-5">
      <div class="d-flex justify-content-between align-items-center mb-3">
        <div class="d-flex align-items-center gap-2">
          <div class="draft-header-icon">
            <i class="pi pi-bookmark"></i>
          </div>
          <h3 class="drafts-title mb-0">{{ 'Draft' | translator }}</h3>
          <span class="drafts-count-badge" *ngIf="data_draft">
            {{ data_draft.length }}
          </span>
        </div>
      </div>

      <!-- Skeleton Loading -->
      <app-skelitions
        [hidden]="!skelition"
        [value]="3"
        class="mb-2 w-100"
      ></app-skelitions>

      <!-- Drafts Table -->
      <div *ngIf="!skelition">
        <p-table
          [value]="data_draft"
          [paginator]="data_draft && data_draft.length > 5"
          [rows]="5"
          responsiveLayout="scroll"
          styleClass="p-datatable-modern"
          *ngIf="data_draft && data_draft.length > 0; else noDraftsTemplate"
        >
          <ng-template pTemplate="header">
            <tr>
              <th style="width: 40%">{{ 'Template title' | translator }}</th>
              <th style="width: 25%">{{ 'before' | translator }}</th>
              <th style="width: 20%">{{ 'the date' | translator }}</th>
              <th style="width: 15%" class="text-center"></th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-draft>
            <tr class="draft-row">
              <td>
                <div class="d-flex align-items-center gap-2">
                  <i class="pi pi-file text-primary font-weight-bold"></i>
                  <span class="font-weight-600 text-dark">{{ draft.object?.name || ('Draft' | translator) }}</span>
                </div>
              </td>
              <td>
                <span class="user-pill">
                  <i class="pi pi-user mx-1"></i>
                  {{ draft.user?.user || '-' }}
                </span>
              </td>
              <td>
                <span class="date-text">
                  <i class="pi pi-calendar mx-1"></i>
                  {{ draft.createdAt | date:'mediumDate' }}
                </span>
              </td>
              <td>
                <div class="d-flex justify-content-center gap-2">
                  <button
                    type="button"
                    (click)="selectItem(draft._id)"
                    class="btn-table-action btn-apply-draft"
                    pTooltip="{{ 'OK' | translator }}"
                    tooltipPosition="top"
                    [disabled]="loadingDraftId === draft._id"
                  >
                    <i *ngIf="loadingDraftId !== draft._id" class="pi pi-check"></i>
                    <i *ngIf="loadingDraftId === draft._id" class="pi pi-spin pi-spinner"></i>
                  </button>

                  <button
                    type="button"
                    (click)="deleteItem(draft._id)"
                    class="btn-table-action btn-delete-draft"
                    pTooltip="{{ 'Delete' | translator }}"
                    tooltipPosition="top"
                  >
                    <i class="pi pi-trash"></i>
                  </button>
                </div>
              </td>
            </tr>
          </ng-template>
        </p-table>

        <ng-template #noDraftsTemplate>
          <div class="empty-drafts-box text-center py-5">
            <i class="pi pi-inbox empty-drafts-icon mb-2"></i>
            <p class="text-muted mb-0">{{ 'No drafts available' | translator }}</p>
          </div>
        </ng-template>
      </div>
    </div>

    <!-- MISSING ENTITIES RESOLUTION SECTION -->
    <div *ngIf="missing_entities.length > 0" class="bulk-entities-card mb-5">
      <div class="entities-header-banner d-flex justify-content-between align-items-center flex-wrap gap-3 mb-4">
        <div class="d-flex align-items-center gap-3">
          <div class="entities-alert-icon">
            <i class="pi pi-exclamation-triangle"></i>
          </div>
          <div>
            <h3 class="mb-1 text-white font-weight-bold">{{ 'Entities' | translator }}</h3>
            <p class="mb-0 text-white-50">
              {{ 'Add all' | translator }} ({{ missing_entities.length }})
            </p>
          </div>
        </div>

        <button
          type="button"
          class="btn-add-all-ou"
          (click)="AddAllDialogShow()"
        >
          <i class="pi pi-plus-circle mx-2"></i>
          {{ 'Add all' | translator }} ({{ missing_entities.length }})
        </button>
      </div>

      <p-table
        [value]="missing_entities"
        [paginator]="missing_entities.length > 10"
        [rows]="10"
        responsiveLayout="scroll"
        styleClass="p-datatable-modern"
      >
        <ng-template pTemplate="header">
          <tr>
            <th>{{ 'Named' | translator }}</th>
            <th>{{ 'Sublevel' | translator }}</th>
            <th>{{ 'Basic level' | translator }}</th>
            <th class="text-center"></th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-item>
          <tr>
            <td>
              <div class="d-flex align-items-center justify-content-between">
                <span class="font-weight-500">{{ item.name }}</span>
                <button
                  type="button"
                  class="btn-change-mini"
                  pTooltip="{{ 'Confirmation of change' | translator }}"
                  (click)="changeName(item.name, item.parent)"
                >
                  <i class="pi pi-angle-down"></i>
                </button>
              </div>
            </td>
            <td>
              <div class="d-flex align-items-center justify-content-between" *ngIf="item.parent">
                <span>{{ item.parent }}</span>
                <button
                  type="button"
                  class="btn-change-mini"
                  pTooltip="{{ 'Confirmation of change' | translator }}"
                  (click)="changeName(item.parent, item.grandparent)"
                >
                  <i class="pi pi-angle-down"></i>
                </button>
              </div>
              <span *ngIf="!item.parent" class="text-muted">-</span>
            </td>
            <td>
              <div class="d-flex align-items-center justify-content-between" *ngIf="item.grandparent">
                <span>{{ item.grandparent }}</span>
                <button
                  type="button"
                  class="btn-change-mini"
                  pTooltip="{{ 'Confirmation of change' | translator }}"
                  (click)="changeName(item.grandparent, null)"
                >
                  <i class="pi pi-angle-down"></i>
                </button>
              </div>
              <span *ngIf="!item.grandparent" class="text-muted">-</span>
            </td>
            <td class="text-center">
              <button
                type="button"
                class="btn-add-single-ou"
                (click)="showDialog(item.name, item.parent, item.grandparent)"
              >
                <i class="pi pi-external-link mx-1"></i>
                {{ 'Adding an organizational unit' | translator }}
              </button>
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>

    <!-- DATA GENERATION & FIELDS / TYPES RESOLUTION -->
    <div
      *ngIf="missing_entities.length == 0 && data.length > 0"
      class="bulk-data-resolved-container"
    >
      <!-- Action Banner -->
      <div class="bulk-ready-card mb-4">
        <div class="d-flex justify-content-between align-items-center flex-wrap gap-3">
          <div class="flex-grow-1">
            <p class="mb-0 text-secondary font-weight-500">
              <i class="pi pi-info-circle text-primary mx-2"></i>
              {{ "The uploaded data's categories have been added to the portal. Click on the button below to generate data and identify any missing fields." | translator }}
            </p>
          </div>
          <button
            type="button"
            class="btn-generate-data"
            (click)="generateData()"
          >
            <i class="pi pi-cog mx-2"></i>
            {{ 'Data generation' | translator }}
          </button>
        </div>
      </div>

      <!-- Missing Fields Alert -->
      <div *ngIf="missing_fields.length > 0" class="missing-items-card mb-4">
        <div class="d-flex align-items-center gap-2 mb-2">
          <i class="pi pi-exclamation-circle text-warning font-1_2rem"></i>
          <h4 class="mb-0 font-weight-bold">{{ 'Missing fields' | translator }}</h4>
        </div>
        <p class="text-muted mb-3">
          The following are the missing fields in the data. You can replace them with existing ones or add new ones from the dashboard.
        </p>
        <div class="d-flex flex-wrap gap-2">
          <button
            type="button"
            *ngFor="let field of missing_fields"
            class="btn-missing-chip"
            (click)="MissingFields(field)"
          >
            <i class="pi pi-plus mx-1"></i>
            {{ field }}
          </button>
        </div>
      </div>

      <!-- Missing Types Alert -->
      <div *ngIf="missing_types.length > 0" class="missing-items-card mb-4">
        <div class="d-flex align-items-center gap-2 mb-2">
          <i class="pi pi-exclamation-circle text-warning font-1_2rem"></i>
          <h4 class="mb-0 font-weight-bold">{{ 'Imperfect species' | translator }}</h4>
        </div>
        <p class="text-muted mb-3">
          {{ 'The following are the missing types in the data. You can replace them with existing ones or add new ones from the dashboard.' | translator }}
        </p>
        <div class="d-flex flex-wrap gap-2">
          <button
            type="button"
            *ngFor="let type of missing_types"
            class="btn-missing-chip"
            (click)="MissingTypes(type)"
          >
            <i class="pi pi-plus mx-1"></i>
            {{ type }}
          </button>
        </div>
      </div>

      <!-- Action Buttons when everything is resolved -->
      <div
        class="d-flex justify-content-center gap-3 my-4 flex-wrap"
        *ngIf="
          missing_entities.length == 0 &&
          missing_fields.length == 0 &&
          missing_types.length == 0 &&
          data_items.length > 0
        "
      >
        <button
          type="button"
          class="btn-upload-all-final"
          (click)="
            UploadAllDataVisible = true;
            loadingprogress = 0;
            loadingprogressTotal = data_items.length
          "
        >
          <i class="pi pi-cloud-upload mx-2"></i>
          {{ 'Download all data' | translator }}
        </button>

        <button
          type="button"
          class="btn-save-draft-final"
          (click)="SaveDraftVisible = true"
        >
          <i class="pi pi-save mx-2"></i>
          {{ 'Save as a draft' | translator }}
        </button>
      </div>

      <!-- Bulkview Component -->
      <app-bulkview
        *ngIf="data_items.length > 0"
        [data]="data_items"
        (outputData)="updateSharedData($event)"
      ></app-bulkview>
    </div>

    <!-- DIALOGS & MODALS -->

    <!-- Download Template Dialog -->
    <p-dialog
      [header]="translate('Download template')"
      [modal]="true"
      [(visible)]="tempdialog"
      [style]="{ width: '90%', maxWidth: '600px' }"
      [draggable]="false"
      [resizable]="false"
    >
      <div class="template-dialog-content py-2">
        <p class="text-muted mb-3">
          {{ 'Add the Excel file to download the data' | translator }}
        </p>
        <div class="template-grid">
          <div
            class="template-grid-card"
            *ngFor="let item of dataTypes"
            (click)="downloadTemplate(item)"
          >
            <div class="template-grid-icon">
              <i class="{{ item.icon }}"></i>
            </div>
            <div class="template-grid-info">
              <span class="template-grid-title">{{ item.arabic || item.name }}</span>
              <span class="template-grid-ext">.xlsx</span>
            </div>
            <div class="template-grid-btn">
              <i class="pi pi-download"></i>
            </div>
          </div>
        </div>
      </div>
    </p-dialog>

    <!-- Change OU Mapping Dialog -->
    <p-dialog
      [blockScroll]="true"
      [draggable]="false"
      id="ouNameChange"
      header="{{ 'Confirmation of change' | translator }}"
      [(visible)]="changedialog"
      [style]="{ width: '90%', maxWidth: '500px' }"
    >
      <div class="p-fluid">
        <div class="mapping-preview-box mb-3">
          <label for="afterChange" class="form-label font-weight-500 mb-2">
            {{ "Do you want to change the organizational unit?" | translator }}
          </label>
          <div class="current-ou-path">
            <i class="pi pi-sitemap mx-2 text-primary"></i>
            <span>{{ beforeparent ? beforeparent + ' > ' : '' }}{{ beforchange }}</span>
          </div>
        </div>

        <div class="mb-3">
          <label class="form-label font-weight-500">
            {{ "Determine the organizational unit" | translator }}
          </label>
          <p-dropdown
            [options]="changeOptions"
            [filter]="true"
            optionLabel="name"
            [(ngModel)]="afterchange"
            placeholder="{{ 'Determine the organizational unit' | translator }}"
            appendTo="body"
            styleClass="w-100"
          ></p-dropdown>
        </div>

        <div class="d-flex justify-content-end gap-2 mt-4">
          <button
            pButton
            type="button"
            icon="pi pi-times"
            label="{{ 'cancellation' | translator }}"
            class="p-button-outlined p-button-secondary"
            (click)="changedialog = false"
          ></button>
          <button
            pButton
            type="button"
            icon="pi pi-check"
            label="{{ 'OK' | translator }}"
            class="p-button-success"
            [disabled]="!afterchange || changeOptions.length === 0"
            (click)="commitchange(beforchange, afterchange, beforeparent)"
          ></button>
        </div>
      </div>
    </p-dialog>

    <!-- Add Single OU Dialog -->
    <p-dialog
      [blockScroll]="true"
      [draggable]="false"
      id="addSingleOu"
      header="{{ 'Adding an organizational unit' | translator }}"
      [(visible)]="visible"
      [style]="{
        width: '90%',
        maxWidth: '520px'
      }"
    >
      <div class="p-fluid">
        <div class="row g-2">
          <div class="col-6 mb-2">
            <label class="form-label small text-muted">{{ "ID" | translator }}</label>
            <input
              type="text"
              pInputText
              [disabled]="true"
              [(ngModel)]="newOu.id"
              class="w-100"
            />
          </div>
          <div class="col-6 mb-2">
            <label class="form-label small text-muted">{{ "Named" | translator }}</label>
            <input
              type="text"
              pInputText
              [disabled]="true"
              [(ngModel)]="newOu.name"
              class="w-100"
            />
          </div>
          <div class="col-12 mb-2">
            <label class="form-label small text-muted">{{ "Sublevel" | translator }}</label>
            <input
              type="text"
              pInputText
              [disabled]="true"
              [value]="newOu.parent?.name"
              class="w-100"
            />
          </div>

          <div class="col-12 mb-2">
            <label class="form-label font-weight-500">{{ "Image/icon" | translator }}</label>
            <p-toggleButton
              [(ngModel)]="ImageRadio"
              onLabel="{{ 'picture' | translator }}"
              offLabel="{{ 'icon' | translator }}"
              [onIcon]="'pi pi-image'"
              offIcon="pi pi-flag"
              styleClass="w-100"
            ></p-toggleButton>
          </div>

          <div class="col-12 mb-2" [hidden]="ImageRadio == true">
            <label class="form-label small text-muted">{{ "Icons" | translator }}</label>
            <p-dropdown
              [options]="iconOptions"
              [filter]="true"
              [(ngModel)]="newOu.image_sq"
              styleClass="w-100"
              appendTo="body"
            >
              <ng-template let-item pTemplate="item">
                <i [ngClass]="item.icon" class="mx-2"></i>
                {{ item.label }}
              </ng-template>
            </p-dropdown>
          </div>

          <div class="col-12 mb-2" [hidden]="ImageRadio == false">
            <label class="form-label small text-muted">{{ "Image" | translator }}</label>
            <div class="p-fileupload">
              <div class="row g-2 align-items-center">
                <div class="col-7">
                  <p-fileUpload
                    mode="basic"
                    name="file"
                    [url]="apilink + 'file/ORGANIZATIONAL_UNIT'"
                    [auto]="true"
                    accept="image/*"
                    [maxFileSize]="1000000"
                    (onUpload)="onUpload($event)"
                  ></p-fileUpload>
                </div>
                <div class="col-5 text-center">
                  <img
                    *ngIf="newOu.image"
                    class="img-fluid center-img rounded"
                    [src]="GlobalConstants.staticFilesURL + newOu.image"
                  />
                </div>
              </div>
            </div>
          </div>

          <div class="col-12 mb-2">
            <label class="form-label small text-muted">{{ "City" | translator }}</label>
            <p-dropdown
              [options]="locations"
              [filter]="true"
              optionLabel="name"
              [(ngModel)]="newOu.location"
              styleClass="w-100"
              appendTo="body"
            ></p-dropdown>
          </div>

          <div class="col-12 mb-2">
            <label class="form-label small text-muted">{{ "Category" | translator }}</label>
            <p-dropdown
              [options]="categories"
              [filter]="true"
              optionLabel="name"
              [(ngModel)]="newOu.category"
              styleClass="w-100"
              appendTo="body"
            ></p-dropdown>
          </div>

          <div class="col-12 mb-3">
            <label class="form-label small text-muted">{{ "Type" | translator }}</label>
            <p-dropdown
              [options]="org_types"
              [filter]="true"
              optionLabel="name"
              [(ngModel)]="newOu.type"
              styleClass="w-100"
              appendTo="body"
            ></p-dropdown>
          </div>

          <div class="col-12 mb-2">
            <button
              pButton
              label="{{ 'OK' | translator }}"
              class="p-button-success w-100"
              (click)="newOuSubmit()"
            ></button>
          </div>

          <div class="col-12" *ngIf="loadingprogress > 0 && loadingprogressTotal != loadingprogress">
            <p-progressBar
              [value]="(loadingprogress / loadingprogressTotal) * 100"
              mode="determinate"
              [showValue]="false"
            ></p-progressBar>
          </div>
        </div>
      </div>
    </p-dialog>

    <!-- Add Bulk OU Dialog -->
    <p-dialog
      [blockScroll]="true"
      [draggable]="false"
      id="addBulkOu"
      header="{{ 'Adding an organizational unit' | translator }}"
      [(visible)]="AddAllvisible"
      [style]="{
        width: '90%',
        maxWidth: '900px'
      }"
    >
      <div class="row g-4">
        <!-- Left Column: Table of Missing Entities -->
        <div class="col-12 col-md-6">
          <div class="bulk-ou-table-wrapper">
            <table class="table table-sm table-hover mb-0">
              <thead class="table-light">
                <tr>
                  <th>#</th>
                  <th>{{ "Named" | translator }}</th>
                  <th>{{ "Sublevel" | translator }}</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let item of missing_entities; let i = index">
                  <td>{{ maxId + i }}</td>
                  <td class="font-weight-500">{{ item.name }}</td>
                  <td class="text-muted">{{ item.parent || '-' }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <!-- Right Column: Settings Form -->
        <div class="col-12 col-md-6">
          <div class="p-fluid">
            <div class="mb-2">
              <label class="form-label font-weight-500">{{ "Image/icon" | translator }}</label>
              <p-toggleButton
                class="w-100"
                [(ngModel)]="ImageRadio"
                onLabel="{{ 'picture' | translator }}"
                offLabel="{{ 'icon' | translator }}"
                [onIcon]="'pi pi-image'"
                offIcon="pi pi-flag"
                styleClass="w-100"
              ></p-toggleButton>
            </div>

            <div class="mb-2" *ngIf="ImageRadio == false">
              <label class="form-label small text-muted">{{ "Icons" | translator }}</label>
              <p-dropdown
                [options]="iconOptions"
                [filter]="true"
                [(ngModel)]="newOu.image_sq"
                styleClass="w-100"
                appendTo="body"
              >
                <ng-template let-item pTemplate="selectedItem">
                  <i class="{{ item.icon }} mx-2"></i> {{ item.label }}
                </ng-template>
                <ng-template let-object pTemplate="item">
                  <i class="{{ object.icon }} mx-2"></i> {{ object.label }}
                </ng-template>
              </p-dropdown>
            </div>

            <div class="mb-2" *ngIf="ImageRadio == true">
              <label class="form-label small text-muted">{{ "Image" | translator }}</label>
              <div class="p-fileupload">
                <div class="row g-2 align-items-center">
                  <div class="col-6">
                    <p-fileUpload
                      [chooseLabel]="'Upload Image'"
                      mode="basic"
                      name="file"
                      [url]="apilink + 'file/ORGANIZATIONAL_UNIT'"
                      [auto]="true"
                      accept="image/*"
                      [maxFileSize]="1000000"
                      (onUpload)="onUpload($event)"
                    ></p-fileUpload>
                  </div>
                  <div class="col-6 text-center">
                    <img
                      *ngIf="newOu.image"
                      class="img-fluid center-big-img rounded"
                      [src]="GlobalConstants.staticFilesURL + newOu.image"
                    />
                  </div>
                </div>
              </div>
            </div>

            <div class="mb-2">
              <label class="form-label small text-muted">{{ "City" | translator }}</label>
              <p-dropdown
                [options]="locations"
                [filter]="true"
                optionLabel="name"
                [(ngModel)]="newOu.location"
                styleClass="w-100"
                appendTo="body"
              ></p-dropdown>
            </div>

            <div class="mb-2">
              <label class="form-label small text-muted">{{ "Category" | translator }}</label>
              <p-dropdown
                [options]="categories"
                [filter]="true"
                optionLabel="name"
                [(ngModel)]="newOu.category"
                styleClass="w-100"
                appendTo="body"
              ></p-dropdown>
            </div>

            <div class="mb-3">
              <label class="form-label small text-muted">{{ "Type" | translator }}</label>
              <p-dropdown
                [options]="org_types"
                [filter]="true"
                optionLabel="name"
                [(ngModel)]="newOu.type"
                styleClass="w-100"
                appendTo="body"
              ></p-dropdown>
            </div>

            <div *ngIf="loadingprogress > 0" class="mb-2">
              <span class="small text-muted">{{ "Download all" | translator }}: {{ ((loadingprogress / loadingprogressTotal) * 100) | number:'1.0-0' }}%</span>
              <p-progressBar [value]="(loadingprogress / loadingprogressTotal) * 100" [showValue]="false"></p-progressBar>
            </div>

            <p *ngIf="bulkerror" class="text-danger small">{{ bulkerror }}</p>

            <div [hidden]="hideBulkOuButton">
              <button
                pButton
                label="{{ 'OK' | translator }}"
                *ngIf="loadingprogress < loadingprogressTotal; else elseBlock"
                class="p-button-success w-100"
                (click)="AddAllDialogSubmit()"
              ></button>
              <ng-template #elseBlock>
                <button
                  pButton
                  label="{{ 'Cancel' | translator }}"
                  class="p-button-danger w-100"
                  (click)="AddAllvisible = false"
                ></button>
              </ng-template>
            </div>

            <div *ngIf="hideBulkOuButton" class="text-center py-2">
              <p-progressSpinner [style]="{ width: '40px', height: '40px' }"></p-progressSpinner>
            </div>
          </div>
        </div>
      </div>
    </p-dialog>

    <!-- Missing Field Dialog -->
    <p-dialog
      [blockScroll]="true"
      [draggable]="false"
      header="Add Missing Field"
      [(visible)]="missingFieldVisible"
      [style]="{ width: '90%', maxWidth: '500px' }"
    >
      <app-dynamic-form
        *ngIf="missingField_updateQuestions.length > 0"
        [questions]="missingField_updateQuestions"
        (sendData)="missingField_create($event)"
      ></app-dynamic-form>
      <p-messages [(value)]="messages" [enableService]="false"></p-messages>
    </p-dialog>

    <!-- Missing Type Dialog -->
    <p-dialog
      [blockScroll]="true"
      [draggable]="false"
      header="{{ 'Assignment to another data type' | translator }}"
      [(visible)]="missingTypeVisible"
      [style]="{ width: '90%', maxWidth: '420px' }"
    >
      <div class="p-fluid py-2">
        <div class="mb-3">
          <label class="form-label font-weight-500 text-muted">{{ "Imperfect species" | translator }}:</label>
          <div class="p-2 bg-light rounded font-weight-bold">{{ missingtype }}</div>
        </div>

        <div class="mb-3">
          <label class="form-label font-weight-500">{{ "type" | translator }}</label>
          <p-dropdown
            [options]="server_data_types"
            [filter]="true"
            optionLabel="arabic"
            [(ngModel)]="missingtypefix"
            styleClass="sstarabic w-100"
            appendTo="body"
          >
          </p-dropdown>
        </div>

        <div class="d-flex justify-content-end gap-2 mt-4">
          <button
            pButton
            type="button"
            icon="pi pi-times"
            label="{{ 'Cancel' | translator }}"
            class="p-button-outlined p-button-secondary"
            (click)="missingTypeVisible = false"
          ></button>
          <button
            pButton
            type="button"
            icon="pi pi-check"
            label="{{ 'OK' | translator }}"
            class="p-button-success"
            [disabled]="missingtypefix == '' || server_data_types.length == 0"
            (click)="missingTypeChange(missingtype, missingtypefix)"
          ></button>
        </div>
      </div>
    </p-dialog>

    <!-- Save Draft Dialog -->
    <p-dialog
      [blockScroll]="true"
      [draggable]="false"
      header="{{ 'Save as a draft' | translator }}"
      [(visible)]="SaveDraftVisible"
      [style]="{ width: '90%', maxWidth: '440px' }"
    >
      <div class="p-fluid py-2">
        <div class="mb-3">
          <label for="draftName" class="form-label font-weight-500">{{
            "Draft name" | translator
          }}</label>
          <input
            type="text"
            id="draftName"
            [(ngModel)]="draftName"
            class="form-control"
            placeholder="{{ 'Enter the name of the draft' | translator }}"
          />
        </div>

        <div class="d-flex justify-content-end gap-2 mt-4">
          <button
            pButton
            type="button"
            label="{{ 'Cancel' | translator }}"
            class="p-button-outlined p-button-secondary"
            (click)="SaveDraftVisible = false"
          ></button>
          <button
            pButton
            type="button"
            icon="pi pi-save"
            label="{{ 'Save' | translator }}"
            class="p-button-primary"
            [disabled]="!draftName.trim()"
            (click)="saveDraft()"
          ></button>
        </div>

        <div *ngIf="draftSaved" class="text-success text-center mt-3 font-weight-500">
          <i class="pi pi-check-circle mx-1"></i>
          {{ "The draft has been saved successfully." | translator }}
        </div>
      </div>
    </p-dialog>

    <!-- Upload All Data Modal -->
    <p-dialog
      [blockScroll]="true"
      [draggable]="false"
      header="{{ 'Download all data' | translator }}"
      [(visible)]="UploadAllDataVisible"
      [style]="{ width: '90%', maxWidth: '620px' }"
    >
      <div class="py-2">
        <div class="d-flex justify-content-between align-items-center mb-3">
          <span class="text-muted">{{ "Data name" | translator }}</span>
          <span class="badge bg-primary rounded-pill">{{ data_items.length }} {{ 'records' | translator }}</span>
        </div>

        <div class="bulk-ou-table-wrapper mb-3" style="max-height: 250px; overflow-y: auto;">
          <table class="table table-sm text-black mb-0">
            <thead>
              <tr>
                <th style="width: 50px">#</th>
                <th>{{ "Data name" | translator }}</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let data of data_items; let i = index">
                <td>{{ i + 1 }}</td>
                <td>{{ data.name }}</td>
              </tr>
            </tbody>
          </table>
        </div>

        <div class="mb-3" *ngIf="loadingprogress > 0">
          <div class="d-flex justify-content-between small text-muted mb-1">
            <span>{{ "Progress" | translator }}</span>
            <span>{{ ((loadingprogress / loadingprogressTotal) * 100) | number:'1.0-0' }}%</span>
          </div>
          <p-progressBar
            [value]="(loadingprogress / loadingprogressTotal) * 100"
            [showValue]="false"
          ></p-progressBar>
        </div>
      </div>

      <ng-template pTemplate="footer">
        <div class="d-flex justify-content-end gap-2 w-100">
          <p-button
            *ngIf="!UploadAllDataVisibleClose"
            icon="pi pi-cloud-upload"
            (click)="UploadAllData(data_items)"
            label="{{ 'Download all' | translator }}"
            styleClass="p-button-success"
          ></p-button>

          <p-button
            *ngIf="UploadAllDataVisibleClose"
            icon="pi pi-times"
            (click)="UploadAllDataVisible = false"
            label="{{ 'Cancel' | translator }}"
            styleClass="p-button-secondary"
          ></p-button>
        </div>
      </ng-template>
    </p-dialog>
  </div>
</div>
<app-footer class="mt-2"></app-footer>
